import { CurrentUser, UserPermission } from "@/types/user"

import { SIGNED_IN_LANDING_PATH } from "@/lib/auth-utils"
import { userInitiatedSignOut } from "@/lib/auth/client"
import { isEuRegion } from "@/lib/region"
import { selectIsXS } from "@/lib/storage/app-slice"
import { useAppSelector } from "@/lib/storage/hooks"
import { Button } from "../ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu"
import { Link } from "../ui/link"
import { UserAvatar } from "../user-avatar"

export function MarketingUserDropdown({
  user,
  permissions,
}: {
  user: CurrentUser
  permissions?: UserPermission[]
}) {
  const isXS = useAppSelector(selectIsXS)
  const canViewOrganization = !!permissions?.includes("can_access_dashboard")

  const handleUserSignOut = async () => {
    void userInitiatedSignOut()
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        render={
          isXS ? (
            <Button variant="ghost" size="xs" circle>
              <UserAvatar user={user} size="2xs" />
            </Button>
          ) : (
            <Button variant="ghost" size="xs" className="min-w-0 pr-2 pl-1.5">
              <UserAvatar user={user} size="2xs" />
              <span className="truncate">{user.handle}</span>
            </Button>
          )
        }
      />
      <DropdownMenuContent>
        {!isEuRegion() && (
          <DropdownMenuItem
            render={<Link href={SIGNED_IN_LANDING_PATH}>Home</Link>}
          />
        )}
        {canViewOrganization && (
          <DropdownMenuItem render={<Link href="/dashboard">Dashboard</Link>} />
        )}
        <DropdownMenuItem render={<Link href="/settings">Settings</Link>} />
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={handleUserSignOut}>Log out</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
